
import { codiciAttributo } from './../constants/CodiciAttributo';

export const codiciAttributoEsperienzaLavoratore = [
  codiciAttributo.TX_ESPERIENZE_ALTRE
];
